import PieChartModuleType from "shared/components/dashboard/PieChartModuleType";

const RingChartModuleType = ({ dashboardId }: { dashboardId: number }) => {
  return <PieChartModuleType dashboardId={dashboardId} />;
};

export default RingChartModuleType;
